import { useEffect, useState } from "react";
import { Checkbox, Input } from "antd";

export default function RecipeAddOnsInputs({ addOnId, currentAddOn, updateAddOns, setSelectedAddOns }) {
  const [isChecked, setIsChecked] = useState(false);
  const [addOnName, setAddOnName] = useState(Boolean(currentAddOn.name) ? currentAddOn.name : "");
  const [addOnPrice, setAddOnPrice] = useState(Boolean(currentAddOn.price) ? currentAddOn.price : "");

  useEffect(() => {

    setIsChecked(Boolean(currentAddOn.isSelected) ? currentAddOn.isSelected : false);
    // setAddOnName(Boolean(currentAddOn.name) ? currentAddOn.name : "");
    // setAddOnPrice(Boolean(currentAddOn.price) ? currentAddOn.price : "");

  }, [currentAddOn]);

  function onHandleCheckbox(e, addOnObj) {
    const checked = e.target.checked;
    // updateAddOns(addOnId, "isSelected", checked);
    if (!checked) {
      setIsChecked(false);
      setSelectedAddOns((prev) => [...prev, { ...addOnObj, isSelected: checked }]);
      return;
    }
    setIsChecked(true);
    setSelectedAddOns((prev) => [...prev, { ...addOnObj, isSelected: checked }]);
  }

  // function onHandleAddOnName(e) {
  //   const val = e.target.value;
  //   updateAddOns(addOnId, "name", val);
  //   setAddOnName(val);
  // }

  // function onHandleAddOnPrice(e) {
  //   const val = e.target.value;
  //   updateAddOns(addOnId, "price", val);
  //   setAddOnPrice(val);
  // }

  return (
    <section>
      <div className="flex items-center space-x-4">
        <Checkbox checked={isChecked} onChange={(e) => onHandleCheckbox(e, currentAddOn)} style={{ height: "24px", width: "24px", transform: "scale(1.2)" }} />
        <div className="w-[340px] h-[42px] recipe-add-ons">
          <Input
            readOnly
            className="cursor-default"
            value={addOnName}
            // onChange={onHandleAddOnName}
            placeholder="Add-Ons"
          />
        </div>
        <div className="w-[84px] h-[42px] recipe-add-ons">
          <Input
            readOnly
            className="cursor-default"
            type="number"
            value={addOnPrice}
            // onChange={onHandleAddOnPrice}
            placeholder="Price"
          />
        </div>
      </div>
    </section>
  );
}
